// 獲取後端 URL，處理 HTTPS 混合內容問題
// 用於一般 HTTP 請求（返回空字符串表示使用相對路徑）
export const getBackendUrl = () => {
  // 在生產環境中，如果頁面是 HTTPS，使用相對路徑（前後端同域名，避免混合內容問題）
  // 這樣會通過反向代理（如 nginx）轉發到後端，不會有混合內容問題
  if (import.meta.env.PROD && window.location.protocol === 'https:') {
    return ''
  }
  
  const envUrl = import.meta.env.VITE_BACKEND_URL
  // 如果有設置環境變數，直接使用
  if (envUrl) {
    // 如果當前頁面是 HTTPS，但後端 URL 是 HTTP，使用相對路徑避免混合內容問題
    if (window.location.protocol === 'https:' && envUrl.startsWith('http://')) {
      return ''
    }
    return envUrl
  }
  
  // 在生產環境中，如果沒有設置環境變數，使用相對路徑（前後端同域名）
  if (import.meta.env.PROD) {
    return ''
  }
  
  // 開發環境回退到 localhost
  return 'http://localhost:8081'
}

// 獲取後端 URL，用於 WebSocket 連接（返回完整 origin）
// WebSocket 需要完整的 URL，不能使用相對路徑
export const getBackendUrlForWebSocket = () => {
  // 在生產環境中，如果頁面是 HTTPS，使用當前域名（前後端同域名，避免混合內容問題）
  if (import.meta.env.PROD && window.location.protocol === 'https:') {
    return window.location.origin
  }
  
  const envUrl = import.meta.env.VITE_BACKEND_URL
  // 如果有設置環境變數
  if (envUrl) {
    // 如果當前頁面是 HTTPS，但後端 URL 是 HTTP，使用當前域名避免混合內容問題
    if (window.location.protocol === 'https:' && envUrl.startsWith('http://')) {
      return window.location.origin
    }
    return envUrl
  }
  
  // 在生產環境中，如果沒有設置環境變數，使用當前域名
  if (import.meta.env.PROD) {
    return window.location.origin
  }
  
  // 開發環境回退到 localhost（與 API 使用相同端口）
  return 'http://localhost:8080'
}

// 安全地訪問會話存儲（支援多帳號同時登入）
export const safeGetSessionStorage = (key) => {
  try {
    return sessionStorage.getItem(key)
  } catch (e) {
    console.warn('訪問會話存儲失敗:', e)
    return null
  }
}

// 安全地訪問本地存儲（僅用於記住登入憑證）
export const safeGetLocalStorage = (key) => {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    console.warn('訪問本地存儲失敗:', e)
    return null
  }
}
